import { INoRowsOverlayAngularComp } from '@ag-grid-community/angular'
import { INoRowsOverlayParams } from '@ag-grid-community/core'
import { Component } from '@angular/core'

@Component({
  selector: 'hs-positions-no-rows-overlay',
  template: `{{ message }}`,
})
export class CustomNoRowsOverlayComponent implements INoRowsOverlayAngularComp {
  message: string | undefined

  agInit(
    params: INoRowsOverlayParams & { noRowsMessageFunc: () => string },
  ): void {
    this.message = params.noRowsMessageFunc()
  }
}
